module.exports = __webpack_public_path__ + "static/media/decoracao_01.4381fe5b.jpg";